import React from 'react';
import type { ESignPackage, Participant } from '../../types/docmagic';
import type { BusyAction } from '../../hooks/usePackages';
import { ParticipantsTable } from '../details/ParticipantsTable';
import { SignedPdfCard } from '../details/SignedPdfCard';
import { SyncLog } from '../details/SyncLog';
interface DetailsTabProps {
  pkg: ESignPackage;
  busy?: BusyAction;
  onRetryPdf: () => void;
  onSendEmail: (p: Participant) => void;
  onSign: (p: Participant) => void;
}
export function DetailsTab({
  pkg,
  busy,
  onRetryPdf,
  onSendEmail,
  onSign
}: DetailsTabProps) {
  return <div className="space-y-4" data-id="element-151" data-mp="1zb8yjejxk9wz">
      <ParticipantsTable pkg={pkg} onSendEmail={onSendEmail} onSign={onSign} data-id="element-152" data-mp="1zahgl6j9aap6" />
      <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]" data-id="element-153" data-mp="1vagq2nivu91r">
        <SignedPdfCard pkg={pkg} busy={busy} onRetry={onRetryPdf} data-id="element-154" data-mp="nwdmm0co4mk4" />
        <SyncLog logs={pkg.logs} data-id="element-155" data-mp="nxoqe0645ub8" />
      </div>
    </div>;
}